import { GraphQLObjectType, GraphQLString, GraphQLInt, GraphQLNonNull, GraphQLID } from 'graphql';

import { connectionArgs, connectionFromArray } from 'graphql-relay';

import cardConnection from '../connections/cardType';
import SectionPerformanceType from './sectionPerformance.gql';

import Node from './node.gql';

const sectionType = new GraphQLObjectType({
  name: 'Section',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: item => item.id
    },
    pid: {
      type: GraphQLString,
      resolve: item => item.pid
    },
    name: {
      type: GraphQLString,
      resolve: item => item.name
    },
    position: {
      type: GraphQLInt,
      resolve: item => item.position
    },
    cards: {
      type: cardConnection,
      args: connectionArgs,
      resolve: (item, args) => connectionFromArray(item.cards.slice(), args)
    },
    sectionPerformance: {
      type: SectionPerformanceType
    }
  }),
  interfaces: [Node.nodeInterface]
});

window[sectionType.name + 'GQLType'] = sectionType;

export default sectionType;
